import React from "react";
import Grid from "../Grid/grid";
import Title from "../title";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import OurWorkCard from "../card/our-work-card";

function OtherCases({
  cases,
  heading,
  handleNavigate,
  buttonTitle,
}: {
  cases: any;
  heading: string;
  handleNavigate: (data: any) => void;
  buttonTitle: string;
}) {
  const navigate = useNavigate();
  const { id, title } = useParams<{ id: any; title: string }>();

  const filteredCases = cases.filter((item: any) => item.id !== parseInt(id));

  const randomCases = filteredCases.sort(() => 0.5 - Math.random()).slice(0, 4);
  return (
    <section className="relative flex flex-col h-auto px-4 sm:px-6 md:px-10 lg:px-16 py-10">
      <Grid direction="top-center" size={100} />
      <div className="z-10 flex justify-start items-start mb-12 w-full">
        <Title title={heading} />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
        {randomCases.map((data: any, index: number) => (
          <OurWorkCard
            data={data}
            index={index}
            handleNavigate={() => handleNavigate(data)}
          />
        ))}
      </div>
    </section>
  );
}

export default OtherCases;
